/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as vscode from 'vscode';
import { $inc } from './util/dispose';

enum Trace {
	Off,
	Verbose
}

namespace Trace {
	export function fromString(value: string): Trace {
		value = value.toLowerCase();
		switch (value) {
			case 'off':
				return Trace.Off;
			case 'verbose':
				return Trace.Verbose;
			default:
				return Trace.Off;
		}
	}
}

export interface ILogger {
	verbose(title: string, message: string, data?: any): void;
}

export class $jnc extends $inc implements ILogger {
	private a?: Trace;

	private b?: vscode.OutputChannel;

	private get h() {
		this.b ??= this.f(vscode.window.createOutputChannel('Markdown'));
		return this.b;
	}

	constructor() {
		super();

		this.f(vscode.workspace.onDidChangeConfiguration(() => {
			this.j();
		}));

		this.j();
	}

	public verbose(title: string, message: string, data?: any): void {
		if (this.a === Trace.Verbose) {
			this.k(`[Verbose ${this.i()}] ${title}: ${message}`);
			if (data) {
				this.k($jnc.m(data));
			}
		}
	}

	private i(): string {
		const now = new Date();
		return String(now.getUTCHours()).padStart(2, '0')
			+ ':' + String(now.getMinutes()).padStart(2, '0')
			+ ':' + String(now.getUTCSeconds()).padStart(2, '0') + '.' + String(now.getMilliseconds()).padStart(3, '0');
	}

	private j(): void {
		this.a = this.l();
	}

	private k(value: string): void {
		this.h.appendLine(value);
	}

	private l(): Trace {
		return Trace.fromString(vscode.workspace.getConfiguration().get<string>('markdown.trace.extension', 'off'));
	}

	private static m(data: any): string {
		if (data instanceof Error) {
			if (typeof data.stack === 'string') {
				return data.stack;
			}
			return data.message;
		}
		if (typeof data === 'string') {
			return data;
		}
		return JSON.stringify(data, undefined, 2);
	}
}
